module.exports = __webpack_public_path__ + "img/avatar.93e8043d.png";